var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whole-page-long"},[_c('div',{staticClass:"navbar-div"},[_c('MarketsReportsComponent',{attrs:{"user":_vm.user,"analysis":"CREATEREPORT"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }